// React
import React from 'react';

// Material UI
import { Grid, Typography } from '@material-ui/core';

// utils
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { fortmatDates, formatCurrencyWithoutCurrency, keyEmptyCheck } from 'aurora-utils/utils';

function After2019({ classes }) {
  const { application } = useSelector(state => state.RentPaymentReducer);

  const { lateFeesAfter2019, lateFeesAfter2019Vat, lateFeeAfter2019StartDate, lateFeeAfter2019EndDate } = application;

  return (
    <Grid container className={classes.borderBottom} spacing={1}>
      <Grid item xs={7}>
        <Typography className={classes.textBold}>{keyEmptyCheck('delayed_rent_after')}</Typography>
      </Grid>
      <Grid item xs={5}>
        <Typography className={classNames(classes.textBold, classes.textEnd)}>
          {keyEmptyCheck('AED_amount', {
            num: formatCurrencyWithoutCurrency(lateFeesAfter2019 + lateFeesAfter2019Vat),
          })}
        </Typography>
      </Grid>

      <Grid item xs={7}>
        <Typography className={classes.textLight}>{keyEmptyCheck('accumulated_rent_amount_for_the_period')}</Typography>
      </Grid>

      <Grid item xs={5}>
        <Typography className={classNames(classes.textEnd)}>
          {keyEmptyCheck('due_rent_amount')} (
          {keyEmptyCheck('AED_amount', { num: formatCurrencyWithoutCurrency(lateFeesAfter2019) })})
        </Typography>
      </Grid>

      <Grid item xs={7}>
        <Typography className={classes.textLight}>
          ( {fortmatDates(lateFeeAfter2019StartDate)} - {fortmatDates(lateFeeAfter2019EndDate)})
        </Typography>
      </Grid>

      <Grid item xs={5}>
        <Typography className={classes.textEnd}>
          {keyEmptyCheck('vat_aed_', { num: formatCurrencyWithoutCurrency(lateFeesAfter2019Vat ?? 0) })}
        </Typography>
      </Grid>
    </Grid>
  );
}

After2019.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default After2019;
